import { h } from 'preact';
import { useRef, useEffect } from 'preact/hooks';
import Image from '../utils/image';

const getImage = ({ url, alt, classes, srcWidths, title }) => (
  <Image
    src={url}
    srcWidths={srcWidths}
    classes={classes}
    alt={alt || title || ''}
  />
);

const getVideo = ({ mediaObject }) => {
  if (!mediaObject?.sources) return null;
  const videoRef = useRef(null);
  const isReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  useEffect(() => {
    const videoEl = videoRef.current;
    if (!videoEl) return;

    if (isReducedMotion) {
      videoEl.pause();
      return;
    }

    const observer = new window.IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          videoEl.play();
        } else {
          videoEl.pause();
        }
      },
      { threshold: 0.75 }
    );

    observer.observe(videoEl);

    // eslint-disable-next-line consistent-return
    return () => {
      observer.disconnect();
    };
  }, [mediaObject, isReducedMotion]);

  return (
    <video
      ref={videoRef}
      loop
      muted
      autoPlay={!isReducedMotion}
      controls={isReducedMotion}
      playsInline
      className={`w-full h-full object-cover`}
    >
      {mediaObject.sources.map((source, index) => (
        <source
          key={`${mediaObject.id}-${index}`}
          src={source.url}
          type={source.mimeType}
        ></source>
      ))}
    </video>
  )
};

const getImageWidths = (isDesktop) =>
  isDesktop
    ? {
        sm: 640,
        md: 768,
        lg: 1024,
        xl: 1280,
        '2xl': 1536,
      }
    : {
        sm: 640,
        md: 768,
        lg: 1024,
      };

// eslint-disable-next-line import/prefer-default-export
export const getBannerMedia = (
  { media, mediaDesktop, mediaMobile, title, isDesktop, isVoyages },
) => {
  const VIDEO_TYPE = 'video';
  if (isVoyages) {
    const isVideoElement =
      mediaDesktop?.type === VIDEO_TYPE || mediaMobile?.type === VIDEO_TYPE;
    if (isVideoElement) {
      return isDesktop
        ? getVideo({ mediaObject: mediaDesktop })
        : getVideo({ mediaObject: mediaMobile });
    }
    return getImage({
          alt: isDesktop ? mediaDesktop?.alt : mediaMobile?.alt,
          url: isDesktop ? mediaDesktop?.url : mediaMobile?.url,
          classes: isDesktop
      ? 'block object-cover object-center h-full w-full'
      : 'w-full',
          srcWidths: getImageWidths(isDesktop),
          title,
        });
  }
  return media?.type === VIDEO_TYPE
    ? getVideo({ mediaObject: media })
    : getImage({
          url: media?.url,
          alt: media?.alt,
          classes: 'w-full',
          srcWidths: getImageWidths(isDesktop),
          title,
        });
};
